import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ContentProvider } from "@/context/ContentContext";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";

function App() {
  const [year] = useState(new Date().getFullYear());
  useEffect(() => {
    document.title = "Mirabella Anemoessa — Luxury Apartment, Pefkochori";
  }, []);
  return (
    <div className="App" data-app-year={year}>
      <ContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
